import Header from '../../../../Components/Header';
import SingleSignOnSideBar from '../../../../Components/SingleSignOnSideBar';
import '../IbaAgentDetails/ibaagentdetails.scss';
import womenImg from '../../../../asset/images/ibaimages/womenImg.svg';
import searchIba from '../../../../asset/images/ibaimages/searchIba.svg';
import IbaAgentAllDetails from '../../componentiba/IbaAgentAllDetails/IbaAgentAllDetails';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import { IBA_Admin_Section } from '../../../../Configuration/API_URL';
import { useNavigate } from 'react-router-dom';


const IbaAgentDetails = () => {
    const [pageStatus, setPageStatus] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [agents, setAgents] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const tableBodyRef = useRef(null);
      const navigate = useNavigate();

    const changePage = (agentData) => {
        setSelectedAgent(agentData);
        setPageStatus(true);
    };


    // const handleScroll = () => {
    //     const table = tableBodyRef.current;
    //     if (!table) return;

    //     const { scrollTop, scrollHeight, clientHeight } = table;
    //     if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && !loading) {
    //         setPage(prev => prev + 1);
    //     }
    // };

    const handleSearch = debounce((value) => {
        setSearchTerm(value.trim());
    }, 400);

    const getAgentDetails = async (value) => {
    const payload ={
      Search: searchTerm
    }
    try {
      const response = await axios.post(
        IBA_Admin_Section.getAgentDetails,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      if (data.status === 0) {
      setAgents(data?.data)

      } else {
        toast.error(data?.message)
        setAgents([])
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(()=>{
    getAgentDetails();
  
  }, [searchTerm]);

const getInitials = (name = "") => {
  if (!name) return "";

  const words = name.trim().split(/\s+/); // handles extra spaces
  const firstInitial = words[0]?.charAt(0).toUpperCase() || "";
  const lastInitial =
    words.length > 1 ? words[words.length - 1].charAt(0).toUpperCase() : "";

  return `${firstInitial}${lastInitial}`;
};

const handlePerformance = (agentData) => {
  navigate("/performance-reports", {
    state: {
      agent: agentData,
    },
  });
};

    return (
        <div>
            <Header portal={"IBA"} />
            <SingleSignOnSideBar />
            {!pageStatus ? (
                <main id="main-content" className="telecallerDash">
                    <div className='card-box iba-page'>
                    <div className="agent-table-wrapper">
                        <div className="wrap-header performance-report">
                            <div className='module-title'>Agent Details</div>
                            <div className="search-bar">
                                <img src={searchIba} alt="searchIba" />
                                <input
                                    type="text"
                                    placeholder="Enter Agent Name or ID"
                                    onChange={(e) => handleSearch(e?.target?.value)}
                                />
                            </div>
                        </div>

                        
                        <table className="agent-table mt-4 ag-details-table">
                            <thead>
                                <tr>
                                    <th>Agent Name</th>
                                    <th>SAP Code</th>
                                    <th>Acc. Opened</th>
                                    <th>Status</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody 
                            // onScroll={handleScroll}
                                ref={tableBodyRef}>
                                {agents?.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center', padding: '10px' }}>No Agents Found</td>
                                    </tr>
                                ) : (
                                    agents?.map((data, index) => (
                                        <tr key={index}>
                                            <td>
                                              <div className="name-cell">
                                                <div className="avatar-text">
                                                    {getInitials(data?.agentName)}
                                                </div>

                                                {data?.agentName}
                                                </div>
                                            </td>
                                            <td>{data?.sapCode}</td>
                                            <td>{data?.accountsOpened}</td>
                                            <td style={{marginLeft: "5px"}}>{data?.status}</td>
                                            <td>
                                              <div className="details-cell">
                                                <span className="link" onClick={() => changePage(data)}>View Details</span>
                                                <button className="performance-btn" onClick={()=> handlePerformance(data)}>Performance</button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    </div>
                </main>
            ) : (
                <IbaAgentAllDetails setPageStatus={setPageStatus} selectedAgent={selectedAgent} 
                refreshAgentList={getAgentDetails} 
                setSelectedAgent={setSelectedAgent}/>
            )}
        </div>
    );
};

export default IbaAgentDetails;
